/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toggle_Prev_Next_DescInputs */



/**
* | output |
* | --- |
* | "Toggle previous and next event view" |
*
* @param {Toggle_Prev_Next_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toggle_prev_next_desc = /** @type {((inputs?: Toggle_Prev_Next_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toggle_Prev_Next_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basculer la vue de l'événement précédent et suivant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ansicht des vorherigen/nächsten Ereignisses umschalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva/disattiva la visualizzazione dell'evento precedente e successivo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переключиться между просмотром предыдущего и следующего события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Alternar vista de evento anterior y siguiente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切换上一个和下一个事件视图")
	if (locale === "ja") return /** @type {LocalizedString} */ ("前のイベントと次のイベントの表示を切り替える")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पिछले और अगले इवेंट व्यू को टॉगल करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alternar visualização do evento anterior e seguinte")
	return /** @type {LocalizedString} */ ("Toggle previous and next event view")
});